import { useEffect, useState } from 'react';
import { useAuth } from '../../../global-components/src';
import { requestLegacyPostLinkPreview } from '../../../utils/legacy-post-link-preview';
import { extractFirstHttpUrl, fallbackLinkPreview, LinkPreviewData } from '../../../utils/social-links';
import { SocialLinkPreview } from './social-link-preview';

interface Props {
  text?: string;
  preview?: LinkPreviewData | null;
  className?: string;
  postId?: number;
}

/**
 * Feed preview. Prefer the snapshot attached to the post by the API and only
 * use a lightweight local fallback for posts created before link_preview.
 */
export const PostLinkPreview = ({ text, preview, className = '', postId }: Props) => {
  const { token } = useAuth();
  const [legacyPreview, setLegacyPreview] = useState<LinkPreviewData | null>(null);
  const fallback = fallbackLinkPreview(text);

  useEffect(() => {
    setLegacyPreview(null);
    const url = extractFirstHttpUrl(text);
    if (preview || !postId || !url) return;

    let active = true;
    requestLegacyPostLinkPreview(postId, url, token).then(result => {
      if (active) setLegacyPreview(result);
    });

    return () => {
      active = false;
    };
  }, [postId, preview, text, token]);

  const resolvedPreview = preview ?? legacyPreview ?? fallback;

  return resolvedPreview ? <SocialLinkPreview preview={resolvedPreview} className={`post-link-preview ${className}`.trim()} /> : null;
};
